import { AttendancePunctuality, AttendanceRotation, AttendanceWing } from './models';

export interface AttendanceChoice<T> {
  value: T;
  label: string;
  /** Dot colour shown on the filter chip. */
  color: string;
}

export const WING_LABELS: Record<AttendanceWing, string> = {
  FIXED_WING: 'Fixed Wing',
  ROTOR_WING: 'Rotor Wing',
};

export const ROTATION_LABELS: Record<AttendanceRotation, string> = {
  ROTATION_A: 'Rotation A',
  ROTATION_B: 'Rotation B',
  ROTATION_C: 'Rotation C',
};

/** Background of the base code badge in the filter's base list. */
export const BASE_BADGE_COLOR = '#2563eb';

export const WING_CHOICES: AttendanceChoice<AttendanceWing>[] = [
  { value: 'FIXED_WING', label: WING_LABELS.FIXED_WING, color: '#7c4cff' },
  { value: 'ROTOR_WING', label: WING_LABELS.ROTOR_WING, color: '#72a82d' },
];

export const ROTATION_CHOICES: AttendanceChoice<AttendanceRotation>[] = [
  { value: 'ROTATION_A', label: ROTATION_LABELS.ROTATION_A, color: '#7e22ce' },
  { value: 'ROTATION_B', label: ROTATION_LABELS.ROTATION_B, color: '#047857' },
  { value: 'ROTATION_C', label: ROTATION_LABELS.ROTATION_C, color: '#ff824e' },
];

/** Value in the shift filter for Rotor Wing days with no shift; the API takes it as `unassignedShift`. */
export const UNASSIGNED_SHIFT = 'UNASSIGNED';

export const UNASSIGNED_SHIFT_CHOICE: AttendanceChoice<string> = {
  value: UNASSIGNED_SHIFT,
  label: 'Unassigned',
  color: '#3b4472',
};

/** Dot colour of a shift chip; the shifts come from the API, so there is no colour per shift. */
export const SHIFT_DOT_COLOR = '#7c4cff';

export const PUNCTUALITY_CHOICES: AttendanceChoice<AttendancePunctuality>[] = [
  { value: 'ON_TIME', label: 'On time', color: '#4da57c' },
  { value: 'LATE', label: 'Late', color: '#ec0303' },
];

export const PAGE_SIZE_OPTIONS = [15, 30, 50];
export const DEFAULT_PAGE_SIZE = 15;
